<template>
  <div class="off-container">
    <img src="@/assets/icon-off.png" alt="">
    <div>视频已下架</div>
  </div>
</template>

<script>
export default {
  name: 'AlbumOff',
  data () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.off-container{
    font-size: 16px;
    background-color: #fff;
    min-height: 100vh;
    img{
        margin-top: 128px;
        width: 224px;
    }
}
</style>
